import React, { Component } from 'react';
import './App.css';

import Navbar from "./Navbar";
import Drawer from "./Drawer";
import Section from "./Section";
import SocialCard from "./SocialCard";

import Art from "./Pages/Art";
import Gifs from "./Pages/Gifs";
import Libraries from "./Pages/Libraries";
import Logos from "./Pages/Logos";
import MDLCalc from "./Pages/MDLCalc";
import Skills from "./Pages/Skills";
import Spotlight from "./Pages/Spotlight";
import Socials from "./Pages/Socials";
import Contact from "./Pages/Contact";


class App extends Component {
  render() {
    return (
      <div className="mdl-layout mdl-js-layout mdl-layout--fixed-header">
        <Navbar />
        <Drawer />

      <div className="portfolio-content mdl-layout__content">
        <Spotlight />
        <MDLCalc />
        <Skills />
        <Logos />
        <Libraries />
        <Gifs />
        <Art />
        <Socials />
        <Contact />
      </div>
    </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js